// assets/pdp-region-availability.js
//
// Extends the buy button with live region-availability re-checks as a
// shopper switches variants (color/size), layered on top of the
// server-rendered initial state from snippets/pdp-buy-button.liquid.
// Mirrors the pattern in assets/pdp-oos-variant-select.js: listens to
// the same variant-picker `change` event, never touches assets/app.js.
(function () {
  function readAvailabilityMap(buyButton) {
    var raw = buyButton.getAttribute('data-region-availability');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }

  function resolveVariantId(root) {
    if (root.currentVariant && root.currentVariant.id) {
      return root.currentVariant.id;
    }
    return root.getAttribute('data-variant');
  }

  function applyRegionState(buyButton, variantId) {
    var btn = buyButton.querySelector('button.product__cta');
    if (!btn) return;

    // The vendor bundle's own buy-button handling already reset
    // disabled/label for this variant based on global sold-out status
    // by the time this runs (registered after it — see theme.liquid
    // script order). If it's already disabled, that's the
    // sold-out-everywhere state, which always wins; don't touch it.
    if (btn.disabled) return;

    var map = readAvailabilityMap(buyButton);
    var available = map[String(variantId)];
    // Missing entry or true => fail-open, leave the button alone.
    if (available === false) {
      btn.disabled = true;
      var label = buyButton.getAttribute('data-region-unavailable-label') || 'Unavailable in Your Region';
      btn.innerHTML = '<span class="text-base font-medium">' + label + '</span>';
    }
  }

  document.querySelectorAll('variant-button, variant-select').forEach(function (root) {
    root.addEventListener('change', function () {
      var buyButton = document.querySelector('buy-button');
      if (!buyButton) return;
      var variantId = resolveVariantId(root);
      if (!variantId) return;
      applyRegionState(buyButton, variantId);
    });
  });

  // Initial page load: the vendor bundle's own buy-button initialization
  // resets disabled/label based on data-available alone, clobbering this
  // project's server-rendered region-unavailable state (confirmed live
  // during Task 5 verification, 2026-08-11). Apply the same check once on
  // load, using the buy-button element's own id attribute — that's exactly
  // the current variant's ID, per snippets/pdp-buy-button.liquid.
  //
  // That reset turned out to happen ASYNCHRONOUSLY, at some point after
  // this script's own synchronous on-load check already ran — so a single
  // one-time check can't reliably win the race (confirmed live during
  // Task 5 verification, 2026-08-11: the vendor's later reset silently
  // undid the correctly-applied region-unavailable state). Watch for
  // further changes and re-apply, matching the MutationObserver pattern
  // assets/pdp-oos-variant-select.js already uses for this exact class of
  // vendor-timing problem.
  document.querySelectorAll('buy-button').forEach(function (buyButton) {
    var variantId = buyButton.id;
    if (!variantId) return;

    applyRegionState(buyButton, variantId);

    // The MutationObserver callback will re-trigger when applyRegionState
    // mutates this buyButton. Callbacks always fire asynchronously in a
    // fresh microtask, so applyingOwnChange alone won't prevent that.
    // The actual loop prevention comes from applyRegionState's guard
    // (if (btn.disabled) return): once the button is disabled on the first
    // invocation, subsequent re-triggered callbacks exit early.
    var applyingOwnChange = false;
    new MutationObserver(function () {
      if (applyingOwnChange) return;
      applyingOwnChange = true;
      applyRegionState(buyButton, variantId);
      applyingOwnChange = false;
    }).observe(buyButton, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });
  });
})();
